import SignUpVerificationSuccess from "./signup-verification-success.container";

export default SignUpVerificationSuccess;